module.exports = __webpack_public_path__ + "static/media/cafe24-body2-3-2.c7aa9194.png";